import { render, staticRenderFns } from "./c_hot_box.vue?vue&type=template&id=3b5f862a&scoped=true&"
import script from "./c_hot_box.vue?vue&type=script&lang=js&"
export * from "./c_hot_box.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5f862a",
  null
  
)

export default component.exports